// extracted by mini-css-extract-plugin
module.exports = {"root":"step5-module--root--IZ-Qz","fileInput":"step5-module--fileInput--34Moc","dropTarget":"step5-module--dropTarget--MOQoC","button":"step5-module--button--3KGHH"};